import React, { Component } from 'react';
import MoreAboutThisTitle from '../views/generic/MoreAboutThisTitle';
import * as MoreAboutThisTitleSelector from '../../data/MoreAboutThisTitleSelector';
import CardContainer from './CardContainer';

class MoreAboutThisTitleContainer extends Component
{
	render()
	{
		var model = MoreAboutThisTitleSelector.getMoreAboutThisTitle();

		return <CardContainer component={MoreAboutThisTitle} cardModel={model}/>
	}
}

export default MoreAboutThisTitleContainer;



// WEBPACK FOOTER //
// ./src/react/containers/MoreAboutThisTitleContainer.jsx